import { createAction, props } from '@ngrx/store';
import { Test } from '../models/test.model';

export const setTest = createAction('[Test Component] SetTest', props<Test>());
